import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import SwitchModal from '../Modals/Switch';

import useStyles from './styles';

const MODES = [
  {
    value: 'diagonal',
    label: 'Diagonal',
    description: 'Revela metade da foto na diagonal. Ao clicar na foto, revela o lado contrário.'
  },
  {
    value: 'circular',
    label: 'Circular',
    description: 'Revela uma área da foto em círculo. Ao arrastar o círculo pela foto, revela outras partes dela.'
  }
];

const ModeCard = ({ label, description, isChecked }) => {
  const classes = useStyles({ isChecked });

  return (
    <Box className={classes.card}>
      {isChecked && (
        <CheckCircleIcon className={classes.checkIcon} fontSize="small" />
      )}
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.description}>{description}</Typography>
    </Box>
  );
};

ModeCard.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired
};

const MobileProtectionModePicker = ({ value, onSave }) => (
  <Grid container spacing={2}>
    {MODES.map((mode) => (
      <Grid item xs={12} sm={6} key={mode.value}>
        <SwitchModal
          name="mobile_anti_copy_mode"
          value={value}
          newValue={mode.value}
          actionLabel={`Usar "${mode.label}"`}
          onSave={onSave}
        >
          <ModeCard
            label={mode.label}
            description={mode.description}
            isChecked={value === mode.value}
          />
        </SwitchModal>
      </Grid>
    ))}
  </Grid>
);

MobileProtectionModePicker.propTypes = {
  value: PropTypes.oneOf(['diagonal', 'circular']),
  onSave: PropTypes.func.isRequired
};

MobileProtectionModePicker.defaultProps = {
  value: 'diagonal'
};

export default MobileProtectionModePicker;
